import axios from "axios";
import Config from "../../config/";
import moment from "moment";
import { toInteger } from "lodash";
const API_KEY = Config.apikey;
const ROOT_URL = Config.rooturl;
const NEW_URL = "http://18.223.168.25:8080/kugiapi/";
console.log(ROOT_URL);


// const GEO_URL = "http://localhost:8080/geoserver/big/ows?service=WFS&version=1.0.0&request=GetFeature&"

export function cekAuth() {
  return {
    headers: {
      Authorization: localStorage.getItem("token"),
    },
  };
}

export function fetchKategori() {
  const url = `${ROOT_URL}featurecatalog`;
  const request = axios.get(url, cekAuth());
  return request;
}

export function fetchPropertyType(fcid, code) {
  const url = `${ROOT_URL}featuretypeproperty?fcid=${fcid}&code=${code}`;
  const request = axios.get(url, cekAuth());
  return request;
}

export function fetchDictionary() {
  const url = `${ROOT_URL}dictionary`;
  const request = axios.get(url, cekAuth());
  return request;
}

export function fetchUnsur(fcid) {
  const url = `${ROOT_URL}featuretype?fcid=${fcid}`;
  const request = axios.get(url, cekAuth());
  return request;
}

export function fetchUnsurCode(fcid, code) {
  const url = `${ROOT_URL}featuretypecode?fcid=${fcid}&code=${code}`;
  const request = axios.get(url, cekAuth());
  return request;
}

export function fetchUnsurDetail(fcid, ftid) {
  const url = `${ROOT_URL}featuretypedetail?fcid=${fcid}&ftid=${ftid}`;
  const request = axios.get(url, cekAuth());
  return request;
}

export function fetchTest(fcid) {
  const url = `http://localhost:8080/users`;
  const request = axios.get(url);
  return request;
}

export function fetchType(fcid) {
  const url = `${ROOT_URL}featuretype?fcid=${fcid}`;
  const request = axios.get(url);
  return request;
}

export function deleteFeatureCatalog(fcid) {
  const url = `${ROOT_URL}featurecatalog/${fcid}`;
  const request = axios.delete(url, cekAuth());
  return request;
}

export function deleteFeatureType(ftid) {
  const url = `${ROOT_URL}featuretype/${ftid}`;
  const request = axios.delete(url, cekAuth());
  return request;
}

export function fetchSearchUnsur_(ptMemberName) {
  const url = `${ROOT_URL}attributesearch?ptMemberName=${ptMemberName}`;
  const request = axios.get(url);
  return request;
}

export function fetchSearchUnsur(fcid, typenya, keyword) {
  const url = `${ROOT_URL}propertyj?fcid=${fcid}&typenya=${typenya}&keyword=${keyword}`;
  const request = axios.get(url);
  return request;
}

export function fetchSearchDomain(lv) {
  const url = `${ROOT_URL}listvaluesearch?lv=${lv}`;
  const request = axios.get(url);
  return request;
}

export function fetchTotalUnsur() {
  const url = `${ROOT_URL}totalunsur`;
  const request = axios.get(url);
  return request;
}
export function fetchPredikatLabel() {
  const url = `${ROOT_URL}label`;
  const request = axios.get(url);
  return request;
}

export function searchrdfquery(predikat, objek, subjek, cancelSignal) {
  // console.log(cancelSignal)
  const url = `${ROOT_URL}ontologi?paramprediket=${predikat}&objek=${objek}&subjek=${subjek}`;
  const request = axios.get(url, {cancelToken: cancelSignal});
  return request;
}

export function uploadRdf(item, name, filename) {
  console.log(item);
  const fdata = new FormData();
  // item.map((data) => {
  //     fdata.append("file", data)
  // })
  fdata.append("file", item);
  if (filename !== "") {
    fdata.append("name", `${name}_${filename}`)
  } else {
    fdata.append("name", `${name}`)
  }
  const url = `${ROOT_URL}fileuploader`;
  const request = axios.post(url, fdata, cekAuth());
  return request;
}

export function prediketList() {
  const url = `${ROOT_URL}prediketlist`;
  const request = axios.get(url);
  return request;
}

export function ontologiMaster(keyword) {
  const url = `${ROOT_URL}ontologiall?paramprediket=ONTOLOGI_MASTER&subjek=${keyword}`
  const request = axios.get(url)
  return request
}

// export function mapData(sublayer, id, filter) {
//   let idFix
//   if (sublayer === 'taswil_kabkot_ar') idFix = `${id}`
//   else idFix = `'${id}'`
//   const url = `${GEO_URL}typeName=big%3A${sublayer}&maxFeatures=50&outputFormat=application%2Fld%2Bjson&CQL_FILTER=${filter}=${idFix}`
//   const request = axios.get(url)
//   return request
// }

export function mapData(item, id) {
  let idFix
  if (item.sublayer === 'taswil_kabkot_ar') idFix = `${id}`
  else idFix = `'${id}'`
  const typeName = `&typename=${item.layer}:${item.sublayer}`
  const filter = `&CQL_FILTER=${item.kategori}=${idFix}`
  const url = `${item.host}${typeName}${filter}`
  const request = axios.get(url)
  return request
}